// extracted by mini-css-extract-plugin
export default {"DropdownItem":"PostDropdown_DropdownItem__otv+M","Menu":"PostDropdown_Menu__9OJJ7","Absolute":"PostDropdown_Absolute__ZCy65","Rel":"PostDropdown_Rel__OLAg7"};